<lib-modal
  [visible]="visible()"
  [title]="'modules.multiUse.title' | translate"
  [contentTemplate]="resolvedTemplate ?? undefined"
  [saveText]="'modules.multiUse.confirm' | translate"
  [cancelText]="'modules.multiUse.cancel' | translate"
  (save)="onConfirm()"
  (cancel)="onCancel()"
  (visibleChange)="visible.set($event)"
></lib-modal>

<ng-template #content>
  <div class="muc">
    <span class="muc__icon" aria-hidden="true"><mat-icon>shield</mat-icon></span>
    <p class="muc__text">{{ 'modules.multiUse.text' | translate: { count: usageCount() } }}</p>
  </div>
</ng-template>
